<template>
  <Menu buttonText="Register Here" />
  <main id="sponsor">
    <sponsorships />
    <pictcarousel :images="cannery" />
  </main>
</template>

<style lang="scss" scoped>
  @import '@/styles/pages/home.scss';
</style>

<script>
import Menu from '@/components/nashville/menu';
import sponsorships from '@/components/nashville/sponsorships.vue';
import pictcarousel from '@/components/nashville/pictcarousel.vue';

export default {
  name: 'Sponsor',
  components: {
    Menu,
    sponsorships,
    pictcarousel
  },
  data() {
    return {
      cannery: [
        require('@/assets/nashville/location/cannery-6.jpg'),
        require('@/assets/nashville/music/rooms/mainstage.jpg'),
        require('@/assets/nashville/music/rooms/stage.jpg'),
        require('@/assets/nashville/location/cannery-3.jpg'),
        require('@/assets/nashville/music/rooms/mil.jpg'),
        require('@/assets/nashville/location/cannery-4.jpeg'),
        require('@/assets/nashville/music/rooms/front.jpg'),
        require('@/assets/nashville/location/cannery-5.jpeg'),
        require('@/assets/nashville/music/rooms/row.jpg'),
        require('@/assets/nashville/location/cannery-7.jpg'),
        require('@/assets/nashville/music/rooms/cannery.jpg')
      ],
    };
  },
};
</script>
